import {OverlayContainer} from "../../../misc/ImageViewer";
import React, {useRef, useState} from "react";
import SchemaEditContainer from "../SchemaEditContainer";
import {SqlQuery} from "../BackTableFieldViewTable";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {BackTableField, setBackTableField} from "../../../../features/schemaManageSlice";
import styled from "styled-components";


type PropsI = {
    closeEditing: () => void,
    addNew?: boolean,
    fieldKey: string,
    field: BackTableField,
};
export default function EditField({closeEditing, addNew = false, fieldKey, field}: PropsI) {
    const tableName = useAppSelector(state => state.schemaManage.back.selectedTable) as string;
    const table = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const [newValue, setNewValue] = useState(field)
    const [haveCustomSql, setHaveCustomSql] = useState(!!field.sqlQuery)
    const [name, setName] = useState(fieldKey)
    const selectJoinRef = useRef<HTMLSelectElement | null>(null);
    const dispatch = useAppDispatch();
    const deleteBackTableFieldJoin = (join: string) => setNewValue(prevState => ({
        ...prevState,
        joinDependencies: prevState.joinDependencies!.filter(j => j !== join)
    }));

    const addBackTableFieldJoin = (join: string) => setNewValue(prevState => ({
        ...prevState,
        joinDependencies: prevState.joinDependencies ? Array.from(new Set(prevState.joinDependencies.concat(join))) : [join]
    }));


    const backPermaFilters = Object.entries(table.permaFilter).filter(([key, x]) => x.depends.includes(fieldKey));
    const outerFields = Object.entries(table.outerFields).filter(([key, x]) => x.depends.includes(fieldKey));
    const deletable = backPermaFilters.length > 0 || outerFields.length > 0;
    return <OverlayContainer $isVisible>
        <SchemaEditContainer>
            <Container>
                <div>{addNew ? "Створити" :"Редагувати"} поле {name}</div>
                {addNew && <div>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)}/>
                </div>}
                <div className="custom-sql">
                    <input type="checkbox" id={'custom-sql'} checked={haveCustomSql} onChange={(e) => {
                        setHaveCustomSql(e.target.checked)
                        setNewValue(prevState => ({
                            ...prevState,
                            sqlQuery: e.target.checked ? `a.${fieldKey} as ${fieldKey}` : undefined
                        }));
                    }
                    }/>
                    <label htmlFor="custom-sql">
                        Кастомний SQL
                    </label>
                </div>
                {newValue.sqlQuery && <div>
                    <SqlQuery sqlQuery={newValue.sqlQuery}/>
                </div>}

                {haveCustomSql &&
                    <div>
                        <div>Нове значення:</div>
                        <div className="new-text-area">
                             <textarea name="newSql" id="newSql" rows={4} value={newValue.sqlQuery?.toString()}
                                       onChange={(e) => setNewValue(prevState => ({
                                           ...prevState,
                                           sqlQuery: e.target.value
                                       }))}></textarea>
                        </div>
                    </div>}


                {newValue.joinDependencies && newValue.joinDependencies.length > 0 &&
                    <div className="edit-field-joins">
                        <div>Необхідні джоїни для цього поля:</div>
                        <div className="edit-field-current-joins">
                            {newValue.joinDependencies.map((key, index) => <div key={index} className="edit-field-join">
                                <div className="edit-field-join-key">
                                    <div>Ключ - {key}</div>
                                    <div className="edit-field-join-delete-join">
                                        <button className={'btn-cmn'}
                                                onClick={() => deleteBackTableFieldJoin(key)}>Видалити
                                        </button>
                                    </div>
                                </div>
                                <div className="value">
                                    {table.joins[key] ? <SqlQuery sqlQuery={table.joins[key]}/> :
                                        <div>Такого джоїна не знайдено</div>}
                                </div>
                            </div>)}
                        </div>
                    </div>
                }
                {((newValue.joinDependencies === undefined && Object.keys(table.joins).length > 0) || (newValue.joinDependencies && Object.keys(table.joins).length > newValue.joinDependencies.length)) &&
                    <div className="edit-field-joins-add">
                        <div>
                            Додати новий джоїн як залежність:
                        </div>
                        <div className={'sel'}>
                            <select name="joins" id="joins" ref={selectJoinRef}>
                                {Object.keys(table.joins).filter(k => newValue.joinDependencies === undefined || !newValue.joinDependencies.includes(k))
                                    .map(k => <option value={k} key={k}>{k}</option>)}
                            </select>
                            <button className={'btn-cmn'}
                                    onClick={() => addBackTableFieldJoin(selectJoinRef.current?.value!)}>Додати
                            </button>
                        </div>
                    </div>
                }
                {backPermaFilters.length > 0 && <div>
                    <div>Перманентні фільтри що залежать від цього поля:</div>
                    {backPermaFilters.map(([key, f]) => <SqlQuery key={key} sqlQuery={f.sql}/>)}
                </div>}
                {outerFields.length > 0 && <div>
                    <div>Зовнішні поля що залежать від цього поля:</div>
                    {outerFields.map(([key, f]) => <SqlQuery key={key} sqlQuery={f.sql}/>)}
                </div>}
                {!addNew && <div className="delete-field">
                    <button className={'btn-cmn'} disabled={deletable} onClick={() => {
                        dispatch(setBackTableField({
                            table: tableName,
                            fieldKey: fieldKey,
                            value: undefined
                        }))
                        closeEditing()
                    }}>
                        Видалити це поле
                    </button>
                    {deletable && <div className="cant-delete">
                        Не можна видалити поле поки є залежні постійні фільтри або зовнішні поля
                    </div>}
                </div>}
                <div className={'controls'}>
                    <button className={'save btn-cmn'} onClick={() => {
                        if (addNew && ethereal && ethereal.fieldsList[name]) {
                            alert("Поле з таким ключем вже є! Змініть ключ")
                            return
                        }
                        dispatch(setBackTableField({
                            table: tableName,
                            fieldKey: name,
                            value: newValue
                        }))
                        closeEditing()
                    }}>
                        Зберегти
                    </button>
                    <button className="close btn-cmn" onClick={closeEditing}>
                        ❌
                    </button>
                </div>
            </Container>
        </SchemaEditContainer>
    </OverlayContainer>

}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: .5rem;

  .delete-field {
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;
    align-items: center;
  }

  .edit-field-joins-add {
    display: flex;
    flex-flow: column;
    gap: .5rem;

    .sel {
      display: flex;
      gap: .5rem;
    }
  }

  .edit-field-joins {
    display: flex;
    flex-flow: column;
    gap: .5rem;

    border-bottom: 2px solid var(--table-action-color);
    border-top: 2px solid var(--table-action-color);

    padding-bottom: .5rem;
    padding-top: .5rem;

    .edit-field-current-joins {
      display: flex;
      flex-flow: column;
      gap: .5rem;

      .edit-field-join {
        border-bottom: 2px solid var(--table-action-color);
        padding-bottom: .5rem;

        &:last-child {
          border-bottom: none;
        }


        .edit-field-join-key {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: .2rem;
        }

        .edit-field-join-delete-join {

        }
      }
    }
  }
`
